import { PayloadAction } from '@reduxjs/toolkit';
import { InteractionName } from '../../types/InteractionName';
import { fedopsLogger } from '../fedopsLogger';

const trackedRequests: { [requestActionType: string]: InteractionName } = {
  FETCH_FREE_TEXT: InteractionName.LOAD_FREE_TEXTS,
  FETCH_CARDS: InteractionName.LOAD_CARDS,
};

type ThunkAction = PayloadAction<
  {
    [key: string]: string;
  },
  string,
  {
    arg: string;
    requestId: string;
    requestStatus: 'pending' | 'rejected' | 'fulfilled';
  },
  never
>;

export const fedopsMiddleware = () => (next) => (action: ThunkAction) => {
  const interaction = trackedRequests[action.type.split('/')[0]];

  if (interaction) {
    if (action.meta.requestStatus === 'pending') {
      fedopsLogger.interactionStarted(interaction);
    } else if (action.meta.requestStatus === 'fulfilled') {
      fedopsLogger.interactionEnded(interaction);
    }
  }

  return next(action);
};
